import { createSelector } from 'reselect';
import { RootState } from '..';

export const selectLoading = (state: RootState) => state.common.loading;
export const selectDrawer = (state: RootState) => state.common.drawer;
export const selectSnackbarState = (state: RootState) => state.common.snackbar;

export const selectUser = (state: RootState) => state.common.user;
export const selectUserToken = (state: RootState) => state.common.user?.token;
export const selectUserRole = (state: RootState) => state.common.user?.role;

export const selectIsAdministrator = createSelector(
    [selectUserRole],
    (role) => role ? role === 'administrator' : false
)
